export const routeProps = {
  path: '/change_password',
  exact: true,
};

export default () => routeProps;
